<template>
  <div class="responsibilityManagementList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 权限说明的折叠板 -->
        <el-collapse v-model="collapse" prop="collapse"> 
          <el-collapse-item :title="$t('lang.lab_privilegeDescription')" class="descrip">
            <div><span class="quote">{{$t('lang.lab_code')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionEncoding')}}</div>
            <div><span class="quote">{{$t('lang.lab_codeName')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionDisplayName')}}</div>
            <div><span class="quote">{{$t('lang.lab_cellRights')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_permissUsedCommunityLocated')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_onlyAuthorizedUsePermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_onlyDevelopersPermission')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_permissionOrdinaryAdministrators')}}{{$t('lang.lab_period')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_contain')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span></div>
            <div><span class="quote">{{$t('lang.lab_category')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionsAre')}}<span class="classical">{{$t('lang.lab_radioSelectionType')}}</span>{{$t('lang.lab_suchAsGender')}}{{$t('lang.lab_asWelllAs')}}
                 <span class="classical">{{$t('lang.lab_multipleSelectionType')}}</span>{{$t('lang.lab_suchAsIndividualPermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_status')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_whetherAvailable')}}</div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addResponsibility')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.responsibilityManagementListCheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 编码 -->
        <el-table-column prop="code" :label="$t('lang.lbl_responsibilityManagementList_code')" ></el-table-column>
        <!-- 名称 -->
        <el-table-column prop="name" :label="$t('lang.lbl_responsibilityManagementList_name')" ></el-table-column>
        <!-- 部门权限 -->
        <el-table-column prop="grade" :label="$t('lang.lbl_responsibilityManagementList_grade')" >
          <template slot-scope="scope">
            <span v-if="scope.row.grade === 0" >{{$t('lang.lab_allDistricts')}}</span>
            <span v-if="scope.row.grade === 1">{{$t('lang.lab_someDistricts')}}</span>
          </template>
        </el-table-column>       
        <!-- 操作权限 -->
        <el-table-column prop="opeateRange" :label="$t('lang.lbl_responsibilityManagementList_opeateRange')" >
          <template slot-scope="scope">
            <span v-if="scope.row.opeateRange === 0" >{{$t('lang.lab_developerPermissions')}}</span>
            <span v-if="scope.row.opeateRange === 1">{{$t('lang.lab_AdministratorRights')}}</span>
          </template>
        </el-table-column>
        <!-- 类别 -->
        <el-table-column prop="authorityType" :label="$t('lang.lbl_responsibilityManagementList_authorityType')" >
          <template slot-scope="scope">
            <span v-if="scope.row.authorityType === 0" >{{$t('lang.lab_singleChoice')}}</span>
            <span v-if="scope.row.authorityType === 1">{{$t('lang.lab_multipleChoice')}}</span>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column prop="flag" :label="$t('lang.lbl_responsibilityManagementList_flag')" >
          <template slot-scope="scope">
            <span v-if="scope.row.flag === 0" >{{$t('lang.lab_notActivated')}}</span>
            <span v-if="scope.row.flag === 1">{{$t('lang.lab_activated')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:responsibilityManagementList
 *@Description:职责管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-26
 */
export default {
  data() {
    return {
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组 
      collapse: [], // 权限说明折叠板
      multipleSelection: [], // 多选框 
      responsibilityManagementListCheckbox: require('@/config/enum').responsibilityManagementListCheckbox, // 是否隐藏复选框
    }
  },
  created () {
    // #8449 add
    setTimeout(() => {
      window.localStorage.setItem('responsibilityManagementForm', '')
      window.localStorage.setItem('responsibilityManagementSaveData', '')
      window.localStorage.setItem('responsibilityManagementTableData', '')
      window.localStorage.setItem('responsibilityManagementSaveOption', '')
    }, 200)
    this.getTablelist()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 职责管理
    getTablelist() {
      let loading = this.$loading()
      this.$get(`/getAuthorityList?pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(id) {
      this.$router.push({ name: 'editResponsibility',
      query: { 
        id: id, 
        flag: true } })
    },
    add() {
      this.$router.push({ name: 'addResponsibility', query: { flag: false } })
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdeleteAuthorityRecommendedPermissionsAvoidDataLoss'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`delAuthorityById/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.responsibilityManagementList{
    .el-collapse-item__header{
      font-size: 16px; 
      padding-left: 0%;  
      margin-left: 0px;
      border-bottom:0px;       
    }
    .el-collapse {
      border-top:0px;
    }
    .el-collapse-item__content{
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      will-change: height;
      background-color: #FFF;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #EBEEF5;
    }
    .quote{
      color:steelblue
    }
    .classical{
      color: #419641
    }
  }
</style>